import { Building2, Droplets, Flame, Landmark, Zap } from "lucide-react";

/** לוח הצבעים. היה בתוך קובץ הרכיב הגדול. */
/* כיוון "אזמרגד" — ירוק אזמרגד עמוק ככותרת ופעולה ראשית, נייר בהיר קריר,
   כרטיסים מעוגלים עם צל רך במקום מסגרת דיו, וצבע ייעודי לכל מונה — צהוב
   לחשמל, כחול למים, חמרה לגז — כדי שהעין תמצא את השדה הנכון בלי לקרוא.
   C.teal נשאר שם המפתח (עשרות שימושים) — הערך הוא ירוק האזמרגד. */
export const C = {
  ink: "#12211D",
  muted: "#6B7F79",
  surface: "#EEF3F1",
  card: "#FFFFFF",
  line: "#E3EDE8",
  teal: "#0E4D42",
  ochre: "#8A6410",
  paid: "#1F7A4D",
  late: "#C24C38",
};

/** צהוב השמש — קו הלשונית הפעילה, פס ההתקדמות על ירוק, וצבע החשמל. */
export const SUN = "#E3A21B";

/* הגרדיאנט של הכותרת הכהה וכרטיס ה"גיבור" — אותה רצועה בכל המסכים. */
export const GRAD = "linear-gradient(160deg, #136B5B 0%, #0E4D42 45%, #0A3A32 100%)";

/* הצבע של כל מונה: הקו בצד הכרטיס, רקע האייקון, וטקסט על הרקע הזה. */
export const METER_HUES = {
  elec: { main: "#E3A21B", bg: "#FDF3DC", text: "#8A6410" },
  water: { main: "#2E8FCC", bg: "#E6F2FB", text: "#1B5E88" },
  gas: { main: "#A85C2A", bg: "#FAEFE6", text: "#A85C2A" },
};

/** האייקון של כל סעיף חיוב. הופרד מ-BILLS כדי ש-@rental/shared ירוץ ב-Node. */
export const BILL_ICONS = {
  vaad: Building2,
  arnona: Landmark,
  municipal: Landmark,
  gas: Flame,
  elec: Zap,
  water: Droplets,
  sewage: Droplets,
};

export const inputStyle = {
  // מסגרת קו רכה ופינות עגולות — שדות של כיוון אזמרגד.
  border: `1.5px solid ${C.line}`,
  borderRadius: 12,
  padding: "8px 10px",
  width: "100%",
  fontSize: 14,
  background: "#FBFDFC",
};

/* שדה קריאת מונה.
   מספר בן 5–7 ספרות שמועתק מהמונה על הקיר, לרוב מהטלפון ובעמידה. הוא היה
   דחוס בשורה אחת יחד עם תאריך ושלושה כפתורים ולא היה מקום למספר עצמו.
   16px הוא גם המינימום שמונע מ-iOS להגדיל את הדף בכל מיקוד בשדה. */
export const readingInputStyle = {
  ...inputStyle,
  fontSize: 18,
  padding: "10px 12px",
  letterSpacing: 0.5,
  fontVariantNumeric: "tabular-nums",
};

export const fontStack = "'Assistant', 'Heebo', system-ui, sans-serif";

/* גוון רקע ופס צבע לכל נכס במסכים שמציגים כמה נכסים זה מתחת לזה (מונים
   וחשבונות). בלי זה כל הקטעים נראים אותו דבר ואפשר להקליד קריאה של דייר
   אחד אצל האחר. הגוונים בהירים מספיק כדי שהכרטיסים הלבנים שבפנים ייראו,
   והפס חזק מספיק כדי שאפשר יהיה להבדיל גם במבט חטוף. */
const APT_TINTS = [
  { bg: "#F4F9F6", bar: "#2E7D62" },
  { bg: "#F7F5FB", bar: "#7A5C8E" },
  { bg: "#FDF6EE", bar: "#C2622B" },
  { bg: "#EEF5FA", bar: "#2C7A99" },
  { bg: "#FBF3F3", bar: "#A8402F" },
  { bg: "#FFF9E6", bar: "#B5822B" },
  { bg: "#F1F4F1", bar: "#6B7F8C" },
  { bg: "#F5F8EE", bar: "#6E8B3D" },
];

/** לפי המיקום ברשימה — יציב כל עוד סדר הנכסים לא משתנה. */
export const aptTint = (index) => APT_TINTS[index % APT_TINTS.length];
